import React, { useEffect, useState } from 'react';
import { issuesAPI } from '../../services/api';

const URGENCY_COLOR = { low: 'green', medium: 'blue', high: 'orange', critical: 'red' };
const STATUS_COLOR = { open: 'orange', in_progress: 'blue', resolved: 'green', closed: 'gray' };

export default function EmployeeIssues() {
  const [issues, setIssues] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    issuesAPI.list().then(({ data }) => setIssues(data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="page-loading">Loading...</div>;

  return (
    <div className="page">
      <div className="page-header">
        <h2>My Issues</h2>
      </div>
      <p className="text-muted mb-4">To raise a new issue, open a task and use the "Raise Issue" button.</p>

      {issues.length === 0 ? (
        <div className="empty-state">No issues raised yet.</div>
      ) : (
        <div className="card">
          <table className="data-table">
            <thead>
              <tr><th>Title</th><th>Task ID</th><th>Urgency</th><th>Status</th><th>HR Response</th><th>Date</th></tr>
            </thead>
            <tbody>
              {issues.map((iss) => (
                <tr key={iss.id}>
                  <td>{iss.title}</td>
                  <td>#{iss.task_id}</td>
                  <td><span className={`badge badge-${URGENCY_COLOR[iss.urgency]}`}>{iss.urgency}</span></td>
                  <td><span className={`badge badge-${STATUS_COLOR[iss.status]}`}>{iss.status}</span></td>
                  <td>{iss.hr_response || <span className="text-muted">Pending</span>}</td>
                  <td>{new Date(iss.created_at).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
